import { Injectable } from '@angular/core';
import { EntityFactoryExtensionService } from '@app/shared/services/entity-factory-extension.service';
import { EntityRepositoryExtensionService } from '@app/shared/services/entity-repository-extension.service';
import {
  EntityAwareServiceClass,
  EntityFactoryService,
  EntityProviderStoreServiceBase,
  EntityRepositoryService,
} from '@technocom/data';
import { Entity, EntityType, EntityValueMapOf } from '@technocom/data/core';

/**
 * Расширение стандартного EntityProviderStoreService для подстройки под сервер.
 **/
@Injectable({
  providedIn: 'root',
})
export class EntityProviderStoreExtensionService<
  T extends Entity = any,
  C extends EntityType<EntityValueMapOf<T>, T> = EntityType<EntityValueMapOf<T>, T>,
> extends EntityProviderStoreServiceBase<T, C> {
  protected readonly type = Entity as any;

  protected getRepository(): EntityAwareServiceClass<EntityRepositoryService> {
    return EntityRepositoryExtensionService;
  }
  protected getFactory(): EntityAwareServiceClass<EntityFactoryService> {
    return EntityFactoryExtensionService;
  }
}
